// Contains Octopus-specific SlickGrid editors
var promptedImage = require('../../img/variables/prompted.png');

(function ($) {

  function OctopusVariableStateFormatter(row, cell, value, columnDef, dataContext) {
    if(value && value.icon)
    {
      return "<i class='fa fa-lg fa-"+value.icon+" "+ value.class + "' title='"+value.title+"'></i>";
    }
    
    if (value === "New") {
      return "<i class='fa fa-lg fa-asterisk text-warning' title='This variable has been added'></i>";
    } else if (value === "Changed") {
      return "<i class='fa fa-lg fa-pencil text-primary' title='This variable has been modified'></i>";
    } else if (value === "Deleted") {
      return "<i class='fa fa-lg fa-remove text-danger' title='When you save, this variable will be deleted'></i>";
    } else {
      return "<i class='fa fa-lg fa-check text-success' title='This variable has not been modified'></i>";
    }
  }

  function escapeVariableValue(string) {
    if (string === null) {
      return "";
    }
    var subs = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': '&quot;',
      "'": '&apos;',
      "/": '&#x2F;'
    };

    var esc = String(string).replace(/[&<>"'\/]/g, function (s) {
      return subs[s];
    });

    return esc.replace(/\n/g, '<strong style="color: #CCC">&para;</strong>');
  }

  function OctopusVariableValueFormatter(row, cell, value, columnDef, dataContext) {
    var result;
    if (dataContext.isSensitive) {
      result = "●●●●●●●●●●";
    } else {
      result = escapeVariableValue(dataContext.value);
    }

    if (dataContext.prompt && dataContext.prompt.label) {
      return "<img src='" + promptedImage + "' alt='This value will be entered at deployment time' width='16' height='16' /> " + result;
    } else {
      return result;
    }
  }

  // Used for a variable value. Shows the variable value with a textarea, and a checkbox for whether it is secure
  var variableValueTemplate = [];
  variableValueTemplate.push("<div style='z-index:1030;position:absolute;' class='slick-edit-dialog slick-cell-editor variable-value-editor'>");
  variableValueTemplate.push("  <textarea hidefocus class='var-edit'></textarea>");
  variableValueTemplate.push("  <div style='text-align: right'>");
  variableValueTemplate.push("    <div class='checkbox' style='float: left; margin-top: 6px;'><label>");
  variableValueTemplate.push("      <input type='checkbox' class='var-sens' style='position: static' /> <span style='vertical-align: top'>Sensitive</span>");
  variableValueTemplate.push("    </label></div>");
  variableValueTemplate.push("    <button style='float: left;' class='btn btn-link var-prompt'>Prompt...</button>");
  variableValueTemplate.push("    <button class='btn btn-success var-save'>Apply</button> ");
  variableValueTemplate.push("    <button class='btn btn-link var-cancel'>Cancel</button>");
  variableValueTemplate.push("  </div>");
  variableValueTemplate.push("</div>");
  var variableValueTemplateString = variableValueTemplate.join("\n");

  function OctopusVariableValueEditor(args) {
    var $val, $isSensitive;
    var scope = this;
    var defaultValue;
    var defaultPrompt;
    var defaultSensitive;
    var prompt;
    var promptLink;

    this.init = function () {
      var editor = $(variableValueTemplateString).appendTo($("#dynamicallyGeneratedContent"));
      var position = $(args.container).offset();
      editor.css("top", (position.top) + "px");
      editor.css("left", position.left + "px");

      $val = $(".var-edit", editor);
      $isSensitive = $(".var-sens", editor);
      $val.resizable({
        handles: "se",
        minHeight: 50,
        minWidth: 450
      });
      $val.bind("keydown", scope.handleKeyDown);

      editor.find(".var-save").bind("click", this.save);
      editor.find(".var-cancel").bind("click", this.cancel);
      editor.find(".var-prompt").bind("click", this.promptDialog);

      promptLink = editor.find(".var-prompt");
      scope.focus();
    };

    this.refreshPromptStatus = function() {
      if (!prompt) {
        promptLink.text("Prompt");
      } else {
        promptLink.text("Change prompt");
      }
    };

    this.promptDialog = function (e) {
      var editorTemplate = [];
      editorTemplate.push("<div class='modal' style='z-index: 10000'><div class='modal-dialog'><div class='modal-content'>");
      editorTemplate.push("  <div class='modal-header'>");
      editorTemplate.push("    <button type='button' class='close' data-dismiss='modal'' aria-hidden='true'>&times;</button>");
      editorTemplate.push("    <h3>Prompt settings</h3>");
      editorTemplate.push("  </div>");
      editorTemplate.push("  <div class='modal-body'>");
      editorTemplate.push("  <div class='form-horizontal'>");
      editorTemplate.push('   <div class="form-group">');
      editorTemplate.push('    <label class="col-sm-3 control-label" for="prompt-label">Label:</label>');
      editorTemplate.push('    <div class="col-sm-9">');
      editorTemplate.push('     <input type="text" id="prompt-label" class="form-control" />');
      editorTemplate.push("    </div>");
      editorTemplate.push("   </div>");
      editorTemplate.push('   <div class="form-group">');
      editorTemplate.push('    <label class="col-sm-3 control-label" for="prompt-description">Description:</label>');
      editorTemplate.push('    <div class="col-sm-9">');
      editorTemplate.push('     <input type="text" id="prompt-description" class="form-control" />');
      editorTemplate.push("    </div>");
      editorTemplate.push("   </div>");
      editorTemplate.push('   <div class="form-group">');
      editorTemplate.push('    <div class="col-md-3"></div>');
      editorTemplate.push('    <div class="checkbox col-md-9">');
      editorTemplate.push("     <label>");
      editorTemplate.push("       <input type='checkbox' id='prompt-required' /> Required");
      editorTemplate.push("     </label>");
      editorTemplate.push("    </div>");
      editorTemplate.push("   </div>");
      editorTemplate.push("  </div>");
      editorTemplate.push("  </div>");
      editorTemplate.push("  <div class='modal-footer'>");
      editorTemplate.push("    <button class='btn btn-success prompt-save'>Apply</button> ");
      editorTemplate.push("    <button class='btn btn-warning prompt-delete'>Delete prompt</button>");
      editorTemplate.push("    <button class='btn btn-link prompt-cancel'>Cancel</button>");
      editorTemplate.push("  </div>");
      editorTemplate.push("</div></div></div>");

      var editor = $(editorTemplate.join('\n'))
        .appendTo("#dynamicallyGeneratedContent");

      var $promptLabel = $("#prompt-label", editor);
      var $promptDescription = $("#prompt-description", editor);
      var $promptRequired = $("#prompt-required", editor);

      if (prompt) {
        $promptLabel.val(prompt.label);
        $promptDescription.val(prompt.description);
        if (prompt.required) {
          $promptRequired.attr("checked", "checked");
        } else {
          $promptRequired.attr("checked", null);
        }
      } else {
        $(".prompt-delete", editor).hide();
      }

      editor.modal({
        backdrop: true
      });

      $promptLabel.focus();

      $("button.prompt-cancel", editor).click(function () {
        editor.modal("hide");
      });

      $("button.prompt-save", editor).click(function () {
        prompt = {
          label: $promptLabel.val(),
          description: $promptDescription.val(),
          required: $promptRequired.is(":checked")
        };
        scope.refreshPromptStatus();
        editor.modal("hide");
      });

      $("button.prompt-delete", editor).click(function () {
        prompt = null;
        scope.refreshPromptStatus();
        editor.modal("hide");
      });
    };

    this.handleKeyDown = function (e) {
      if (e.which === $.ui.keyCode.ENTER && e.ctrlKey) {
        scope.save();
      } else if (e.which === $.ui.keyCode.ESCAPE) {
        e.preventDefault();
        scope.cancel();
      } else if (e.which === $.ui.keyCode.TAB && e.shiftKey) {
        e.preventDefault();
        args.grid.navigatePrev();
        return false;
      } else if (e.keyCode === $.ui.keyCode.LEFT || e.keyCode === $.ui.keyCode.RIGHT || (e.keyCode === $.ui.keyCode.ENTER && e.shiftKey)) {
        e.stopImmediatePropagation();
      } else if (e.keyCode === $.ui.keyCode.TAB) {
        e.preventDefault();
        args.grid.navigateNext();
        return false;
      }
    };

    this.save = function () {
      args.commitChanges();
    };

    this.cancel = function (e) {
      if (e) {
        e.preventDefault();
      }
      scope.refreshPromptStatus();
      $val.val(defaultValue);
      if (defaultSensitive) {
        $isSensitive.attr("checked", "checked");
      } else {
        $isSensitive.attr("checked", null);
      }
      args.cancelChanges();
      return false;
    };

    this.destroy = function () {
      $("#dynamicallyGeneratedContent").empty();
    };

    this.focus = function () {
      $val.focus();
    };

    this.serializeValue = function () {
      return {
        value: ($val.val() || '').trim(),
        prompt: prompt,
        isSensitive: $isSensitive.is(":checked")
      };
    };

    this.applyValue = function (item, state) {
      item.value = state.value;
      item.isSensitive = state.isSensitive;
      item.prompt = state.prompt;
    };

    this.loadValue = function (item) {
      prompt = defaultPrompt = item.prompt;
      scope.refreshPromptStatus();
      $val.val(defaultValue = item.value);
      $val.select();
      defaultSensitive = item.isSensitive;
      if (item.isSensitive) {
        $isSensitive.attr("checked", "checked");
      } else {
        $isSensitive.attr("checked", null);
      }
    };

    this.isValueChanged = function () {
      return (!($val.val() === "" && defaultValue === null)) && ($val.val() !== defaultValue) || $isSensitive.is(":checked") !== defaultSensitive || angular.toJson(prompt) !== angular.toJson(defaultPrompt);
    };

    this.validate = function () {
      return {
        valid: true
      };
    };

    this.init();
  }

  function OctopusVariableScopeToString(scope, variableSettings) {
    if (!scope) {
      return "";
    }

    var fields = [];

    _.chain(variableSettings.scopeOptions).map(function (a) { return a; }).reverse().each(function(option) {
      var valueDictionary = {};

      _.each(option.values, function(v) {
        valueDictionary[v.id] = v.name;
      });

      if (scope[option.name] && scope[option.name].length > 0) {
        var selected = [];
        _.each(scope[option.name], function(selection) {
          selected.push(valueDictionary[selection]);
        });
        fields.push(selected.join(", "));
      }
    });
    
    return fields.join("; ");
  }

  function OctopusVariableScopeFormatter(row, cell, value, columnDef, dataContext) {
    return OctopusVariableScopeToString(value, columnDef.variableSettings);
  }

  function OctopusVariableScopeEditor(args) {
    var columnDef = args.column;
    //var variableSettings = columnDef.variableSettings;

    var self = this;

    var inlineEditor;
    var modifiedScope = {};
    var originalScope;

    this.init = function () {
      var editorTemplate = args.isFilter ?
          '<button class="variable-scope-editor filter">Show all</button>' :
          '<button class="variable-scope-editor" style="color: #555555; margin: 0; padding: 0; font-style: italic; background: transparent; border: none; box-shadow: none">Press enter to edit scope</button>';

      inlineEditor = $(editorTemplate)
        .appendTo(args.container)
        .keydown(self.handleKeyDown)
        .click(function () {
          var controller = angular.element(args.container).scope();
          controller.showScopePicker(modifiedScope, args.isFilter, function(result){
            if(result) {
              modifiedScope = result;
              self.save();
            }
            inlineEditor.focus();
          });
        });

      self.focus();
    };

    this.handleKeyDown = function (e) {
      if (e.which === $.ui.keyCode.ENTER) {
        e.stopImmediatePropagation();
        return true;
      } else if (e.which === $.ui.keyCode.TAB && e.shiftKey) {
        e.preventDefault();
        args.grid.navigatePrev();
        return false;
      } else if (e.keyCode === $.ui.keyCode.TAB) {
        e.preventDefault();
        args.grid.navigateNext();
        return false;
      }
    };

    this.save = function () {
      args.commitChanges();
    };

    this.cancel = function (e) {
      if (e) {
        e.preventDefault();
      }
      args.cancelChanges();
      return false;
    };

    this.destroy = function () {
      $(args.container).empty();
    };

    this.focus = function () {
      inlineEditor.focus();
    };

    this.serializeValue = function () {
      return modifiedScope;
    };

    this.applyValue = function (item, state) {
      item.scope = state;
    };

    this.loadValue = function (item) {
      modifiedScope = item.scope;
      originalScope = item.scope;
    };

    this.isValueChanged = function () {
      if (_.difference(Object.keys(modifiedScope), Object.keys(originalScope)).length !== 0
      || _.difference(Object.keys(originalScope), Object.keys(modifiedScope)).length !== 0) {
        return true;
      }

      for(var prop in modifiedScope) {
        if(_.difference(modifiedScope[prop], originalScope[prop]).length !== 0
        || _.difference(originalScope[prop], modifiedScope[prop]).length !== 0) {
          return true;
        }
      }
      return false;
    };

    this.validate = function () {
      return {
        valid: true
      };
    };

    this.init();
  }

  function OctopusVariableSourceFormatter(row, cell, value, columnDef, dataContext) {
    return value ? "<a href='#"+value.link + "'>" + value.name + "</a>" : "";
  }

  $.extend(true, window, {
    "Slick": {
      "Editors": {
        "OctopusVariableValue": OctopusVariableValueEditor,
        "OctopusVariableScope": OctopusVariableScopeEditor
      },
      "Formatters": {
        "OctopusVariableValue": OctopusVariableValueFormatter,
        "OctopusVariableState": OctopusVariableStateFormatter,
        "OctopusVariableScope": OctopusVariableScopeFormatter,
        "OctopusVariableSource": OctopusVariableSourceFormatter
      },
      "Helpers": {
        "OctopusVariableScopeToString": OctopusVariableScopeToString
      }
    }
  });
})(jQuery);



//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/ui/slick.octopus.js
// module id = 711
// module chunks = 1